// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ResultsSection_wrap__UeG9X {
  margin-top: var(--space-5);
  padding: 0 var(--space-2);       /* comfy side padding on mobile */
}

.ResultsSection_title__zQ-KV {
  margin: 0 0 var(--space-3) 0;
  color: var(--text-primary);
  font-weight: 700;
  font-size: clamp(1.1rem, 1.02rem + 0.32vw, 1.28rem);
  line-height: 1.28;
  letter-spacing: -0.014em;
}

.ResultsSection_patient__9kP\\+S {
  color: var(--primary);
  font-weight: 700;
}

/* Responsive grid: fills rows with cards, minimum width controls wraps */
.ResultsSection_grid__pwgYn {
  display: grid;
  gap: var(--space-3);
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
}

/* Wider screens: give content a comfortable max width */
.ResultsSection_container__8vU1N {
  max-width: 1200px;
  margin: 0 auto;
  background: var(--bg);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: var(--space-4);
  box-shadow: var(--shadow-xs);
}

/* Tighten vertical rhythm on small phones */
/* Phones: the results already sit inside a page card, so drop the second frame. */
@media (max-width: 480px) {
  .ResultsSection_wrap__UeG9X { margin-top: var(--space-4); padding: 0; }
  .ResultsSection_grid__pwgYn { gap: var(--space-2); }
  .ResultsSection_container__8vU1N { padding: 0; border: 0; box-shadow: none; background: transparent; }
  .ResultsSection_title__zQ-KV { font-size: 1rem; overflow-wrap: anywhere; }
}

/* Respect reduced motion */
@media (prefers-reduced-motion: reduce) {
  * { transition: none !important; }
}
`, "",{"version":3,"sources":["webpack://./src/components/DashBoard/ResultsSection.module.css"],"names":[],"mappings":"AAEA;EACE,0BAA0B;EAC1B,yBAAyB,QAAQ,iCAAiC;AACpE;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;EAChB,mDAAmD;EACnD,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,mBAAmB;EACnB,2DAA2D;AAC7D;;AAEA,wDAAwD;AACxD;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,+BAA+B;EAC/B,+BAA+B;EAC/B,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA,4CAA4C;AAC5C,kFAAkF;AAClF;EACE,8BAAQ,0BAA0B,EAAE,UAAU,EAAE;EAChD,8BAAQ,mBAAmB,EAAE;EAC7B,mCAAa,UAAU,EAAE,SAAS,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;EAC/E,+BAAS,eAAe,EAAE,uBAAuB,EAAE;AACrD;;AAEA,2BAA2B;AAC3B;EACE,IAAI,2BAA2B,EAAE;AACnC","sourcesContent":["@import url('../../colors.css');\n\n.wrap {\n  margin-top: var(--space-5);\n  padding: 0 var(--space-2);       /* comfy side padding on mobile */\n}\n\n.title {\n  margin: 0 0 var(--space-3) 0;\n  color: var(--text-primary);\n  font-weight: 700;\n  font-size: clamp(1.1rem, 1.02rem + 0.32vw, 1.28rem);\n  line-height: 1.28;\n  letter-spacing: -0.014em;\n}\n\n.patient {\n  color: var(--primary);\n  font-weight: 700;\n}\n\n/* Responsive grid: fills rows with cards, minimum width controls wraps */\n.grid {\n  display: grid;\n  gap: var(--space-3);\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n}\n\n/* Wider screens: give content a comfortable max width */\n.container {\n  max-width: 1200px;\n  margin: 0 auto;\n  background: var(--bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: var(--space-4);\n  box-shadow: var(--shadow-xs);\n}\n\n/* Tighten vertical rhythm on small phones */\n/* Phones: the results already sit inside a page card, so drop the second frame. */\n@media (max-width: 480px) {\n  .wrap { margin-top: var(--space-4); padding: 0; }\n  .grid { gap: var(--space-2); }\n  .container { padding: 0; border: 0; box-shadow: none; background: transparent; }\n  .title { font-size: 1rem; overflow-wrap: anywhere; }\n}\n\n/* Respect reduced motion */\n@media (prefers-reduced-motion: reduce) {\n  * { transition: none !important; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ResultsSection_wrap__UeG9X`,
	"title": `ResultsSection_title__zQ-KV`,
	"patient": `ResultsSection_patient__9kP+S`,
	"grid": `ResultsSection_grid__pwgYn`,
	"container": `ResultsSection_container__8vU1N`
};
export default ___CSS_LOADER_EXPORT___;
